import clsx from 'clsx'
import PropTypes from 'prop-types'
import ConnectorIcon from './ConnectorIcon'

export default function MatchStepConnector({ children, className }) {
  return (
    <div
      className={clsx(
        'relative z-10 flex flex-row justify-center gap-6',
        className
      )}
    >
      {children}
      <div className='absolute left-1/2 top-1/2 z-0 hidden -translate-x-1/2 -translate-y-1/2 md:block'>
        <ConnectorIcon />
      </div>
    </div>
  )
}

MatchStepConnector.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}
